module.exports = __webpack_public_path__ + "img/devotion.6286e198.png";